import { z } from 'zod';
import { ROLES } from './roles.js';

export const emailSchema = z.string().trim().toLowerCase().email('อีเมลไม่ถูกต้อง').max(254);
export const passwordSchema = z.string().min(8, 'รหัสผ่านอย่างน้อย 8 ตัวอักษร').max(128);
export const roleSchema = z.enum(ROLES);

export const loginSchema = z.object({
  email: emailSchema,
  password: z.string().min(1).max(128),
  device_id: z.string().uuid().optional(),
});

export const refreshSchema = z.object({
  refresh_token: z.string().min(20).max(200),
  device_id: z.string().uuid().optional(),
});

export const changePasswordSchema = z.object({
  current_password: z.string().min(1).max(128),
  new_password: passwordSchema,
});

export const createUserSchema = z.object({
  email: emailSchema,
  display_name: z.string().trim().min(1).max(100),
  role: roleSchema,
});

export const updateUserSchema = z
  .object({
    display_name: z.string().trim().min(1).max(100).optional(),
    role: roleSchema.optional(),
    is_active: z.boolean().optional(),
    reset_password: z.literal(true).optional(),
  })
  .refine((v) => Object.keys(v).length > 0, 'ไม่มีข้อมูลที่จะแก้ไข');

export const WHS_CODE_RE = /^[A-Z0-9][A-Z0-9_.-]{0,19}$/;

export const createWarehouseSchema = z.object({
  whs_code: z
    .string()
    .trim()
    .toUpperCase()
    .regex(WHS_CODE_RE, 'รหัสคลังใช้ได้เฉพาะ A-Z 0-9 - _ . (ไม่เกิน 20 ตัว)'),
  whs_name: z.string().trim().min(1, 'กรุณากรอกชื่อคลัง').max(100),
});

export const updateWarehouseSchema = z
  .object({
    whs_name: z.string().trim().min(1).max(100).optional(),
    is_locked: z.boolean().optional(),
    is_active: z.boolean().optional(),
  })
  .refine((v) => Object.keys(v).length > 0, 'ไม่มีข้อมูลที่จะแก้ไข');

export const IMPORT_TYPES = ['items', 'uoms', 'barcodes'] as const;
export type ImportType = (typeof IMPORT_TYPES)[number];
export const importTypeSchema = z.enum(IMPORT_TYPES);
export const IMPORT_MODES = ['ALL_OR_NOTHING', 'VALID_ONLY'] as const;
export const importCommitSchema = z.object({
  preview_id: z.string().uuid(),
  mode: z.enum(IMPORT_MODES).default('ALL_OR_NOTHING'),
});

export const paginationSchema = z.object({
  page: z.coerce.number().int().min(1).default(1),
  page_size: z.coerce.number().int().min(1).max(200).default(50),
});

export type LoginInput = z.infer<typeof loginSchema>;
export type CreateUserInput = z.infer<typeof createUserSchema>;
export type UpdateUserInput = z.infer<typeof updateUserSchema>;
export type CreateWarehouseInput = z.infer<typeof createWarehouseSchema>;
export type UpdateWarehouseInput = z.infer<typeof updateWarehouseSchema>;
